import SkeletonRow from "./SkeletonRow";

export default SkeletonRow;